
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.563 12.562a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zM2.513 18.149h3.862c-.037-.3-.075-.9 0-1.575.15-1.163.638-2.213 1.237-3.038-.3-.075-.637-.075-.974-.075-4.875-.037-4.125 4.688-4.125 4.688zM17.325 12.562c1.313 0 2.4-1.05 2.4-2.4 0-1.35-1.05-2.4-2.4-2.4-1.313 0-2.4 1.05-2.4 2.4 0 1.35 1.087 2.4 2.4 2.4zM17.4 13.424c-.412 0-.787.037-1.125.112.6.825 1.275 1.838 1.35 3a7.09 7.09 0 010 1.575l3.863.075c0-.037.75-4.762-4.088-4.762zM16.95 18.113c.038-.15.3-2.438-1.087-4.05-.863-1.013-2.175-1.5-3.863-1.5-1.688 0-2.963.487-3.825 1.5-1.275 1.462-1.163 3.487-1.088 4.05M14.7 8.625a2.769 2.769 0 01-2.775 2.775A2.769 2.769 0 019.15 8.625a2.769 2.769 0 012.775-2.775A2.769 2.769 0 0114.7 8.625z","fill":"#fff"}})])
          )
        }
      }
    